<template>
  <div>
    <!-- begin #sidebar -->
    <div
      id="sidebar"
      class="sidebar"
      v-bind:class="{ 'sidebar-transparent': pageOptions.pageSidebarTransparent }"
    >
      <!-- begin sidebar scrollbar -->
      <vue-custom-scrollbar class="height-full">
        <!-- begin sidebar user -->
        <!-- <sidebar-nav-profile></sidebar-nav-profile> -->
        <!-- end sidebar user -->

        <!-- begin sidebar nav -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
          "
        >
          <sidebar-nav
            ref="sidebarNav"
            v-bind:scrollTop="scrollTop"
            v-on:showFloatSubmenu="handleShowFloatSubmenu"
            v-on:hideFloatSubmenu="handleHideFloatSubmenu"
          ></sidebar-nav>
          <div class="copyright">
            <p>
              AHM Spareparts {{ version }}
              <br />
            </p>
            <div class="logout-section" @click="logout">
              <img src="@/assets/img/logout-icon.svg" alt="Logout" class="logout-icon mr-2" />
              <span>Logout</span>
            </div>
          </div>
        </div>
        <!-- end sidebar nav -->
      </vue-custom-scrollbar>
      <!-- end sidebar scrollbar -->
      <!-- begin sidebar minify button overlay -->
      <div class="sidebar-minify-overlay">
        <a href="javascript:;" class="sidebar-minify-btn" v-on:click="handleSidebarMinify()">
          <img src="@/assets/img/sidebar-arrow-icon.svg" alt="Minify" class="minify-icon" />
        </a>
      </div>
      <!-- end sidebar minify button overlay -->
    </div>
    <div class="sidebar-bg"></div>
    <!-- end #sidebar -->
    <div class="mobile-click" v-on:click="dismissSidebar"></div>

    <div
      class="float-sub-menu-container"
      @mouseover="clearHideFloatSubmenu"
      @mouseleave="handleHideFloatSubmenu"
      v-if="this.pageOptions.pageSidebarMinified"
      v-bind:class="{
        'd-none': !this.floatSubmenu,
      }"
      v-bind:style="{
        top: this.floatSubmenuTop,
        left: this.floatSubmenuLeft,
        bottom: this.floatSubmenuBottom,
        right: this.floatSubmenuRight,
      }"
    >
      <div
        class="float-sub-menu-arrow"
        v-bind:style="{
          top: this.floatSubmenuArrowTop,
          bottom: this.floatSubmenuArrowBottom,
        }"
      ></div>
      <div
        class="float-sub-menu-line"
        v-bind:style="{
          top: this.floatSubmenuLineTop,
          bottom: this.floatSubmenuLineBottom,
        }"
      ></div>
      <ul class="float-sub-menu">
        <template v-for="menu in this.floatSubmenuMenu">
          <sidebar-nav-list
            ref="sidebarNavList"
            v-bind:menu="menu"
            v-bind:status="menu.status"
            v-on:calcFloatSubmenu="handleCalcFloatSubmenu"
          ></sidebar-nav-list>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarNav from "./SidebarNav.vue";
import SidebarNavProfile from "./SidebarNavProfile.vue";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions.js";
import VueCustomScrollbar from "vue-custom-scrollbar";
import { version } from "./../../../package.json";

export default {
  name: "Sidebar",
  components: {
    SidebarNav,
    SidebarNavProfile,
    SidebarNavList,
    VueCustomScrollbar,
  },
  data() {
    return {
      scrollTop: "",
      pageOptions: PageOptions,
      floatSubmenu: false,
      floatSubmenuMenu: "",
      floatSubmenuTop: "",
      floatSubmenuBottom: "",
      floatSubmenuLeft: "",
      floatSubmenuRight: "",
      floatSubmenuArrowTop: "",
      floatSubmenuArrowBottom: "",
      floatSubmenuLineTop: "",
      floatSubmenuLineBottom: "",
      clearSubmenu: "",
      subMenuOffset: "",
      version,
    };
  },
  directives: {
    scroll: {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            el.removeEventListener("scroll", f);
          }
        };
        el.addEventListener("scroll", f);

        if (typeof Storage !== "undefined") {
          if (localStorage.sidebarScroll) {
            el.scrollTop = localStorage.sidebarScroll;
          }
        }
      },
    },
  },
  methods: {
    handleCalcFloatSubmenu: function () {
      setTimeout(() => {
        var targetTop = this.subMenuOffset.top;
        var windowHeight = window.innerHeight;
        var targetHeight = document.querySelector(".float-sub-menu-container").offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = this.subMenuOffset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);
    },
    handleShowFloatSubmenu: function (data, offset) {
      this.floatSubmenuMenu = data;
      this.floatSubmenu = true;
      this.subMenuOffset = offset;

      var targetTop = offset.top;
      var windowHeight = window.innerHeight;

      setTimeout(() => {
        var targetHeight = document.querySelector(".float-sub-menu-container").offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = offset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);

      this.floatSubmenuRight = "auto";
      this.floatSubmenuLeft = document.getElementById("sidebar").offsetLeft + offset.width + "px";

      clearTimeout(this.clearSubmenu);
    },
    handleHideFloatSubmenu: function () {
      this.clearSubmenu = setTimeout(() => {
        this.floatSubmenu = false;
      }, 250);
    },
    clearHideFloatSubmenu: function () {
      clearTimeout(this.clearSubmenu);
    },
    handleScroll: function (evt) {
      this.scrollTop = evt.target.scrollTop;
      if (typeof Storage !== "undefined") {
        localStorage.setItem("sidebarScroll", this.scrollTop);
      }
    },
    dismissSidebar: function () {
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
    },
    handleSidebarMinify: function () {
      this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
    },
    logout() {
      this.$store.dispatch("setUser", null);
      this.$http.defaults.headers.common["Authorization"] = "";
      this.$store.state.lastData = null;

      // delete filter data when log out
      this.$store.dispatch("setFilterOptions", null);
      this.$store.state.modules = null;
      localStorage.removeItem("date_expired");
      localStorage.removeItem("isRemember");
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style>
#sidebar {
  background: #fff !important;
  /* border-top: 1px solid grey !important;
		*/
}

.sidebar {
  padding-top: 0;
  border-right: 1px solid #e4e4e4;
  position: relative;
}

.sidebar .nav > li.nav-header {
  color: grey !important;
}

.sidebar .nav > li > a .caret {
  width: 12px;
  height: 6px;
  margin-left: auto;
  display: inline-block;
  filter: brightness(0) saturate(100%) invert(82%) sepia(0%) saturate(0%) hue-rotate(0deg)
    brightness(95%);
  transition: filter 0.2s ease;
}

.sidebar .nav > li > a:hover .caret,
.sidebar .nav > li:hover > a .caret {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg)
    brightness(85%) contrast(96%);
}

.sidebar .nav > li > a {
  color: #bebebe !important;
  padding: 10px 20px;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar .nav > li > a .menu-title {
  flex: 1;
}

.sidebar .nav > li > a:hover {
  color: #cd2e2c !important;
}

.sidebar .nav > li.active > a,
.sidebar .nav > li.active > a i {
  color: #cd2e2c !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
  background: transparent !important;
}

.sidebar .nav > li.active .icon-img img,
.sidebar .nav > li.has-sub.active .icon-img img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg)
    brightness(85%) contrast(96%) !important;
}

/* Ensure icon container doesn't clip icons */
.sidebar .nav > li > a,
.sidebar .nav > li > a .icon-img {
  overflow: visible !important;
}

.sidebar .nav > li {
  overflow: visible !important;
}

.sidebar .nav .sub-menu > li > a {
  color: #bebebe !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

.sidebar .nav .sub-menu > li > a:hover {
  color: #cd2e2c !important;
}

.sidebar .nav > li.active > a .caret {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg)
    brightness(85%) contrast(96%);
}

.sidebar .sub-menu > li.active > a {
  color: #cd2e2c !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

.sidebar .sub-menu > li:before,
.sidebar .sub-menu > li:after,
.sidebar .sub-menu > li > a:after,
.sidebar .sub-menu > li.active:after {
  background: transparent;
  border-color: transparent;
}

.sidebar-minify-overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

.sidebar-minify-btn {
  background-color: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  border: 1px solid #e4e4e4 !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  max-width: 32px !important;
  max-height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 0 !important;
  position: absolute !important;
  right: -16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 1001 !important;
  pointer-events: auto !important;
  cursor: pointer !important;
  transition: box-shadow 0.2s ease !important;
}

.sidebar-minify-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.sidebar-minify-btn .minify-icon {
  width: 10px;
  height: 13px;
  display: block !important;
  margin: 0 0 0 7px !important;
  padding: 0 !important;
  object-fit: contain;
  object-position: center;
  line-height: 0;
  flex-shrink: 0;
}

.page-sidebar-minified .sidebar .copyright p {
  font-size: 10px;
  padding: 4px;
}

.sidebar .copyright {
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible !important;
}

.sidebar .copyright p {
  color: #b5b5b5;
  font-size: 8px;
  max-width: 150px;
  text-align: center;
  margin-bottom: 10px;
}

.logout-section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #3e3e3e;
  font-size: 12px;
  cursor: pointer;
  overflow: visible !important;
  padding: 0;
  margin: 0;
}

.logout-section:hover {
  color: #e1071e;
}

.logout-section:hover .logout-icon {
  filter: brightness(0) saturate(100%) invert(15%) sepia(98%) saturate(5535%) hue-rotate(348deg)
    brightness(91%) contrast(93%);
}

.logout-icon {
  width: 13px;
  height: 13px;
  min-width: 13px;
  min-height: 13px;
  display: block;
  transition: filter 0.2s ease;
  margin: 0;
  padding: 0;
  object-fit: contain;
  object-position: center;
  overflow: visible;
  line-height: 0;
}

.page-sidebar-minified .logout-section span {
  display: none;
}
</style>
